import { viperApi, clinicalApiPath } from '@/services/viper-api'
import qs from 'qs'

export const trialsService = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/trials`,

  getTrials(organizationId, params) {
    return viperApi.get(this.basePath(organizationId), {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' })
      }
    })
  },

  getTrial(organizationId, trialId) {
    return viperApi.get(this.basePath(organizationId) + `/${trialId}`)
  },

  update(orgId, trialId, dto) {
    return viperApi.put(`${this.basePath(orgId)}/${trialId}`, dto)
  }
}
